<!--Element单选树形控件-->
<template>
	<div class="el_Tree_Body" :style="bodyStyle">
		<div class="elTree_hideButton">
			<div class="elTree_hideButton1" v-show="isShow" @click="isShow=!isShow">
				<el-button size="mini" icon="iconfont iconleft_shousuo"></el-button>
			</div>
			<div class="elTree_hideButton2" v-show="!isShow" @click="isShow=!isShow">
				<el-button size="mini" icon="iconfont iconrigth_shousuo"></el-button>
			</div>
		</div>
		<transition name="el-zoom-in-center">
		<div v-show="isShow" class="elTree_body">
		<div style="display: flex;padding-top:10px;align-items: center;">
			<el-input placeholder="输入关键字进行过滤" v-model="filterText" size="small" style='width: 180px;margin-left: 15px;'>
			</el-input>
		</div>
		<el-scrollbar style="height:95%;width: 100%;">
			<el-tree :data="data" :accordion="true" :default-expanded-keys="defaultExpanded" :expand-on-click-node="false" :current-node-key='defaultDevice' node-key="pkid" :props="defaultProps" :highlight-current='true' :filter-node-method="filterNode" ref="tree" @node-click="nodeClick">
				<span class="custom-tree-node" slot-scope="{node, data}">
			    <img src="../../../../public/static/image/elTree/1.9.png" v-show="node.data.type=='group'&&node.data.unitid!=''"/>
			 	<img src="../../../../public/static/image/elTree/2.0.png" v-show="node.data.type=='group'&&node.data.unitid==''"/>
			 	<img src="../../../../public/static/image/elTree/2.1.png" v-show="node.data.type=='virtualDevice'"/>
			 	<span style="padding-left: 5px;">{{node.label }}</span>
				</span>
			</el-tree>
		</el-scrollbar>
		</div>
	 </transition>
	</div>
</template>
<script>
	export default {
		components: {},
		props: {
			dataList: {
				type: Array,
				required: true,
				default: []
			},
		},
		data() {
			return {
				filterText: '',
				data: [],
				defaultProps: {
					children: 'children',
					label: 'label'
				},
				isShow: true,
			}
		},
		created() {},
		mounted() {
			if(!isempty(this.dataList)) {
				this.data = this.dataList
			}
		},
		destroyed() {},
		computed: {
			bodyStyle() {
				let width = '0px'
				if(this.isShow) {
					width = '2.5rem'
				}
				return {
					"width": width
				}
			},
			getResourcesByName() {
				return this.$store.resourcesStore.getters.getResourcesByName
			},
			nowVirtualDevice() {
				return this.$store.deviceStore.state.nowVirtualDevice
			},
			nowDevice() {
				let nowDevice = this.nowVirtualDevice
				if(!isempty(nowDevice)) {
					nowDevice.label = nowDevice.name
				}
				return nowDevice
			},
			defaultExpanded(){
				let list=[]
				list.push(this.defaultDevice)
				return list
			},
			defaultDevice() {
				if(isempty(this.nowDevice)) {
					if(!isempty(this.dataList)) {
						this.digui(this.dataList)
					}
				}
				this.$emit('checkItem',this.nowDevice)
				return isempty(this.nowDevice) ? '' : this.nowDevice.pkid
			}
		},
		watch: {
			filterText(val) {
				this.$refs.tree.filter(val);
			},
			dataList(nv, ov) {
				if(!isempty(nv)) {
					this.data = this.dataList
				}
			},
		},
		methods: {
			filterNode(value, data) {
				if(!value) return true;
				return data.label.indexOf(value) !== -1;
			},
			nodeClick(value, nodeData) {
				value.name = value.label
				this.$emit('checkItem',value)
				this.$store.deviceStore.commit('setNowVirtualDevice', value)
			},
			digui(list) {
				list.forEach(item => {
					if(!isempty(item.children)) {
						this.digui(item.children)
					} else {
						if(item.type == 'virtualDevice') {
							if(isempty(this.nowVirtualDevice)) {
								this.$store.deviceStore.commit('setNowVirtualDevice', item)
							}
						}
					}
				})
			}
		}
	}
</script>

<style>
	.el_Tree_Body .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content{
		background-color:#bed5ef;
	}
</style>